// `step-3.component.ts`
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HorarioService } from '../../../services/horario.service';
import { ReservaService } from '../../../services/reserva.service';
import { TarifarioService } from '../../../services/tarifario.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Tarifario } from '../../../interfaces/utilidades/tarifario.interface';
import { NgForOf, NgIf } from '@angular/common';
import {response} from 'express';

@Component({
  selector: 'app-step-3',
  templateUrl: './step-3.component.html',
  imports: [
    NgForOf,
    NgIf
  ],
  styleUrl: './step-3.component.css'
})
export class Step3Component implements OnInit {
  @Input() step2Data: any; // Receive step-2 data
  horariosDisponibles: any[] = [];
  selectedHorarios: number[] = [];
  totalPrice: number = 0;
  subtotalPrice: number = 0;
  @Output() stepCompleted = new EventEmitter<void>();

  constructor(
    private horarioService: HorarioService,
    private reservaService: ReservaService,
    private tarifarioService: TarifarioService,
    private message: NzMessageService
  ) {}

  ngOnInit(): void {
    if (this.step2Data) {
      this.loadHorariosDisponibles(this.step2Data.fecha_reserva, this.step2Data.id_campo);
    }
  }

  loadHorariosDisponibles(fecha: string, idCampo: number): void {
    this.horarioService.verificarHorariosDisponibles(fecha, idCampo).subscribe((data) => {
      this.horariosDisponibles = data;
    });
  }

  toggleHorario(horarioId: number): void {
    const index = this.selectedHorarios.indexOf(horarioId);
    if (index > -1) {
      this.selectedHorarios.splice(index, 1);
    } else {
      this.selectedHorarios.push(horarioId);
    }
    this.calculateSubtotal();
  }

// `step-3.component.ts`
  calculateSubtotal(): void {
    const data = {
      id_campo: Number(this.step2Data.id_campo),
      id_persona_juridica: Number(this.step2Data.id_persona_juridica),
      id_tipo_dia: Number(this.step2Data.id_tipo_dia),
      horarios: this.selectedHorarios.map(Number)
    };

    console.log('Datos enviados para calcular el subtotal:', data); // Mostrar en consola

    this.reservaService.calcularSubtotal(data).subscribe(
      (response: any) => {
        console.log('Respuesta del servidor:', response);
        this.subtotalPrice = Number(response.subtotal); // Convertir subtotal a número
        this.calculateTotal(); // Calcular el total después de obtener el subtotal
      },
      (error) => {
        this.message.error('Error al calcular el subtotal');
        console.error('Error al calcular el subtotal:', error);
      }
    );
  }
  createReserva(): void {
    const descuentoInput = document.querySelector('.descuento') as HTMLInputElement;
    const motivoDescuentoInput = document.querySelector('.motivo') as HTMLInputElement;

    const descuento = parseFloat(descuentoInput.value) || 0; // Descuento por defecto a 0 si no se coloca valor
    const motivoDescuento = motivoDescuentoInput.value;

    const reservaData = {
      ...this.step2Data,
      horarios: this.selectedHorarios,
      descuento: descuento,
      motivo_descuento: motivoDescuento
    };

    console.log('Datos de reserva enviados:', reservaData); // Mostrar en consola

    this.reservaService.createReserva(reservaData).subscribe(
      (response) => {
        this.message.success('Reserva creada exitosamente');
      },
      (error) => {
        const errorMessage = error.error.message || 'Error al crear la reserva';
        this.message.error(`${errorMessage}`);
      //  console.error('Error al crear la reserva:', error);
      }
    );
    this.stepCompleted.emit();
  }

  get totalHorasSeleccionadas(): number {
    return this.selectedHorarios.length;
  }

  calculateTotal(): void {
    const descuentoInput = document.querySelector('.descuento') as HTMLInputElement;
    const descuento = parseFloat(descuentoInput.value) || 0;
    this.totalPrice = Number((this.subtotalPrice - (this.subtotalPrice * (descuento / 100))).toFixed(2)); // Redondear a dos decimales
  }
}
